import { render, staticRenderFns } from "./OpenClawMobile.vue?vue&type=template&id=47a8b557&scoped=true"
import script from "./OpenClawMobile.vue?vue&type=script&lang=js"
export * from "./OpenClawMobile.vue?vue&type=script&lang=js"
import style0 from "./OpenClawMobile.vue?vue&type=style&index=0&id=47a8b557&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a8b557",
  null
  
)

export default component.exports